import CancelablePromise from '@atpoint/atpjs/cancelable_promise'
import Upload from '@forms/components/upload'
import { List, Map as immutableMap } from 'immutable'
// NOTE: this component wraps the Upload component.
import { Component } from 'react'

import type { MetaType } from '@forms/components/upload'

const MAX_FILE_SIZE = 10 * 1024 * 1024

type FileUploadProps = {
  onChange: (file: File | null) => void
  value: File | null
  errorMessage?: string | boolean | null
  id?: string
  title: string
}

class FileUpload extends Component<FileUploadProps> {
  static defaultProps = {
    value: null,
    errorMessage: immutableMap(),
  }

  deleteDocument = () => {
    const { value, onChange } = this.props
    if (value) {
      onChange(null)
    }
  }

  downloadDocument = () => {
    return CancelablePromise.resolve()
    // Do nothing...
  }

  uploadDocument = (file: File, _meta: MetaType) => {
    const { onChange } = this.props
    if (file) {
      onChange(file)
    }
    return CancelablePromise.resolve()
    // onChange(files.reduce((arr, file) => arr.concat(file), this.props.value))
  }

  render() {
    const { errorMessage, value: file, title: label, id } = this.props
    const documents = (
      file
        ? List([file]).map((file) =>
            immutableMap({
              contentType: file.type,
              id: `${file.lastModified}_${file.name}`,
              blob: file,
              size: file.size,
              filename: file.name,
            }),
          )
        : List()
    ) as List<immutableMap<string, unknown> | any>

    return (
      <Upload
        documents={documents}
        errorMessage={errorMessage}
        id={id}
        label={label}
        maxFileSize={MAX_FILE_SIZE}
        deleteDocument={this.deleteDocument}
        downloadDocument={this.downloadDocument}
        uploadDocument={this.uploadDocument}
      />
    )
  }
}

export default FileUpload
